import { ViewEditModeContextProvider } from 'app/context/ViewEditModeContext/ViewEditModeContext';

import { Pack } from '../Pack';

export const ModernPackDetails = () => {
  return (
    <ViewEditModeContextProvider>
      <Pack />
    </ViewEditModeContextProvider>
  );
};
